import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    memberInvites: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_MEMBER_INVITE_SELECT_IDS (store, ids) {
      store.memberInvites.selectIds = ids
    },
    REMOVE_MEMBER_INVITE_SELECT_IDS (store, ids) {
      store.memberInvites.selectIds = store.memberInvites.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_MEMBER_INVITE_SELECT_ID (store, id) {
      store.memberInvites.selectId = id
    },
    SET_MEMBER_INVITE_FILTERS (store, filters) {
      store.memberInvites.filters = filters
    },
    SET_MEMBER_INVITE_PAGINATE (store, val) {
      store.memberInvites.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getMemberInvites: (store, getters) => {
      return store.memberInvites.selectIds.map((id) => {
        return getters['entities/memberInvites/find'](id)
      })
    },
    getMemberInvitesFilters: (store, getters) => {
      return store.memberInvites.filters
    },
    getMemberInvitesPaginate: (store, getters) => {
      return store.memberInvites.paginate
    },
    getMemberInvite: (store, getters) => {
      return getters['entities/memberInvites/find'](store.memberInvites.selectId) || {}
    }
  },
  actions: {
    /*
    selectMemberInvites
    */
    selectMemberInvites ({commit, dispatch, getters, state}, filters) {
      return dispatch('getMemberInvites', filters)
      .then((response) => {
        commit('SET_MEMBER_INVITE_FILTERS', filters)
        commit('SET_MEMBER_INVITE_PAGINATE', response)
        commit('SET_MEMBER_INVITE_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectMemberInvites
    */
    refreshSelectMemberInvites ({commit, dispatch, getters, state}) {
      return dispatch('selectMemberInvites', getters.getMemberInvitesFilters)
    },
    /*
    selectMemberInvite
    */
    selectMemberInvite ({commit, dispatch, getters, state}, id) {
      return dispatch('getMemberInviteById', id)
      .then((response) => {
        commit('SET_MEMBER_INVITE_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getMemberInvites
    */
    getMemberInvites ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/member-invites`, {params: filters})
      .then((response) => {
        return dispatch('entities/memberInvites/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.memberInvites || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getMemberInviteById
    */
    getMemberInviteById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/member-invites/${id}`)
      .then((response) => {
        return dispatch('entities/memberInvites/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.memberInvites[0]
      })
    },
    /*
    createMemberInvite
    */
    createMemberInvite ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/member-invites`, data)
      .then((response) => {
        return dispatch('entities/memberInvites/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.memberInvites[0]
      })
    },
    /*
    updateMemberInvite
    */
    updateMemberInvite ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/member-invites/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/memberInvites/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.memberInvites[0]
      })
    },
    /*
    deleteMemberInvite
    */
    deleteMemberInvite ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/member-invites/${id}`)
      .then((response) => {
        commit('REMOVE_MEMBER_INVITE_SELECT_IDS', [id])
        dispatch('entities/memberInvites/delete', id)
        return {}
      })
    },

    /*
    resendMemberInvite
    */
    resendMemberInvite ({commit, dispatch, getters, state}, id) {
      return axios
      .post(`/accounts/${getters.getAccount._id}/member-invites/${id}/resend-invite`, {})
      .then((response) => {
        return dispatch('entities/memberInvites/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.memberInvites[0]
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/MemberInvite.js